import React, { useState } from 'react';

import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const FilterBox = ({getInventory}) => {
  const [rarity, setRarity] =useState([{level: 'All', checked: false},{level: 'Low', checked: false},{level: 'Medium', checked: false},{level: 'High', checked: false}])
  const [typeArray, setTypeArray] = useState([{level: 'All', checked: false},{level: 'Fighter', checked: false},{level: 'Potioner', checked: false},{level: 'Master', checked: false}])
  const [sale, setSale] = useState([{level: 'All', value: 'ALL', checked: false},{level: 'Auction Only', value: 'AUCTION', checked: false},
  {level: 'Fixed Price', value: 'FIXED', checked: false}])
  const [rarityType, setRarityType] = useState('');
  const [saleType, setSaleType] = useState('');
  const [type, setType] = useState('');
  const setRarityBox = (value) => {
    setRarityType(value);
    setRarity(rarity.map(rar => rar.level === value ? {...rar, checked : !rar.checked} : {...rar, checked: false}))}
  const setTypeBox = (value) =>  {
    setType(value);
    setTypeArray(type.map(typ => typ.level === value ? {...typ, checked : !typ.checked} : {...typ, checked: false}))}
  const setSaleBox = (value) => {
     setSaleType(value)
     setSale(sale.map(sle => sle.value === value ? {...sle, checked : !sle.checked} : {...sle, checked: false}))
    }
 
  return (
    <div className="filter-box">
      <div className="sub-filter">
        <div className="first-div">
          <div>
          <h5>RARITY</h5>
          {rarity.map((rar, index) => (
            <label>
            <Checkbox
              checked={rar.checked}
              id="follow-ido-twitter"
              type="checkbox"
              // onChange={()=>setRarityBox(rar.level)}
            />
            <div>
              {rar.level} 
            </div>
          </label>
          ))}
          </div>
          <div>
          <h5 className="typ-heading">TYPE</h5>
          {typeArray.map(tp => (
            <label>
            <Checkbox
              checked={tp.checked}
              id="follow-ido-twitter"
              type="checkbox"
              // onChange={() => setTypeBox(tp.level)}
            />
            <div>
              {tp.level} 
            </div>
          </label>
          ))}
          </div>
        </div>
        <div className="sec-div">
          <h5>PRICE</h5>
          <div className="inputs-div">
          <input type="number" disabled className="form-control" placeholder="From"/> 
          <span>-</span>
          <input type="number"  disabled className="form-control" placeholder="to"/>
          </div>
          <Range  key={1} min={ 0} max={10}
            //  onAfterChange={durationFilter}
            disabled
            defaultValue={[0,  10]} 
          // tipFormatter={value => `${value} hrs`}
           />
           <div className="range-div">
             <span>0 $MONS</span>
             <span>5,000 $MONS</span>
           </div>
          <h5>SALE TYPE</h5>
          {sale.map(sa => (
            <label>
            <Checkbox
              checked={sa.checked}
              id="follow-ido-twitter"
              type="checkbox"
              // onChange={() => setSaleBox(sa.value)}
            />
            <div>
              {sa.level} 
            </div>
          </label>
          ))}
        </div>
        <div className="last-div">
          <h5>ATTRIBUTES</h5>
          <div>
            <span>ATTACK</span>
            <Range  key={1} min={ 0} max={10}
            //  onAfterChange={durationFilter}
            disabled
            defaultValue={[0,  10]} 
          // tipFormatter={value => `${value} hrs`}
           />
          </div>
          <div>
            <span>SPEED</span>
            <Range  key={1} min={ 0} max={10}
            //  onAfterChange={durationFilter}
            disabled
            defaultValue={[0,  10]} 
          // tipFormatter={value => `${value} hrs`}
           />
          </div>
          <div>
            <span>DEFENSE</span>
            <Range  key={1} min={ 0} max={10}
            //  onAfterChange={durationFilter}
            disabled
              defaultValue={[0,  10]} 
          // tipFormatter={value => `${value} hrs`}
           />
          </div>
          <div>
            <span>HEALTH</span>
            <Range  key={1} min={ 0} max={10}
            disabled
            defaultValue={[0,  10]} 
           />
          </div>
        </div>
      </div>
      <button onClick={()=> getInventory(type, rarityType, saleType)} className="btn buy">Apply Filters</button>
      <button className="btn">Reset Filters</button>
    </div>
    
  )
}

export default FilterBox;